import { Icon, IconProps } from "./Icon";

export function IconCheckmark(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M7.96 20 0 12.71.71 12l7.25 6.59L23.29 4l.71.71L7.96 20z" />
    </Icon>
  );
}
